(function () {
  'use strict';

  var root = document.querySelector('[data-exact-collection-count-root]');
  if (!root) return;

  var handle = root.getAttribute('data-collection-handle') || '';
  if (!handle) return;

  var sentinelPattern = /\b25,?001\b/g;
  var cacheKey = 'fms-exact-collection-count:v1:' + handle.toLocaleLowerCase();
  var cacheLifetime = 5 * 60 * 1000;
  var exactCount = null;

  function formattedCount(count) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
  }

  function updateCountLabels(count) {
    var replacement = formattedCount(count);
    root.querySelectorAll('[data-exact-collection-product-count]').forEach(function (element) {
      if (sentinelPattern.test(element.textContent)) {
        sentinelPattern.lastIndex = 0;
        element.textContent = element.textContent.replace(sentinelPattern, replacement);
      }
      sentinelPattern.lastIndex = 0;
    });
  }

  function showHonestFallback() {
    root.querySelectorAll('[data-exact-collection-product-count]').forEach(function (element) {
      element.textContent = element.textContent.replace(sentinelPattern, '25,000+');
      sentinelPattern.lastIndex = 0;
    });
  }

  function readCache() {
    try {
      var cached = JSON.parse(sessionStorage.getItem(cacheKey));
      if (cached && Number.isInteger(cached.count) && Date.now() - cached.savedAt < cacheLifetime) {
        return cached.count;
      }
    } catch (error) {
      // Storage can be disabled; the live collection request still works.
    }
    return null;
  }

  function writeCache(count) {
    try {
      sessionStorage.setItem(cacheKey, JSON.stringify({ count: count, savedAt: Date.now() }));
    } catch (error) {
      // A cache failure should never prevent the exact count from being shown.
    }
  }

  function observeCountChanges() {
    var observer = new MutationObserver(function () {
      if (exactCount !== null) updateCountLabels(exactCount);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  var cachedCount = readCache();
  if (cachedCount !== null) {
    exactCount = cachedCount;
    updateCountLabels(exactCount);
    observeCountChanges();
    return;
  }

  fetch('/collections/' + encodeURIComponent(handle) + '.json', {
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Exact collection count request failed: ' + response.status);
      return response.json();
    })
    .then(function (payload) {
      var count = payload && payload.collection && payload.collection.products_count;
      if (!Number.isInteger(count)) throw new Error('Exact collection count response was incomplete');
      exactCount = count;
      writeCache(count);
      updateCountLabels(count);
      observeCountChanges();
    })
    .catch(function () {
      showHonestFallback();
    });
})();
